/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Csl,
  PubListConfig,
} from '../models/index';
import {
    CslFromJSON,
    CslToJSON,
    PubListConfigFromJSON,
    PubListConfigToJSON,
} from '../models/index';

export interface GetCslRequest {
    pubListConfig: PubListConfig;
}

export interface GetSingleCslRequest {
    workId: number;
    locale?: string;
}

/**
 * 
 */
export class PublistCslApi extends runtime.BaseAPI {

    /**
     * Creates request options for getCsl without sending the request
     */
    async getCslRequestOpts(requestParameters: GetCslRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pubListConfig'] == null) {
            throw new runtime.RequiredError(
                'pubListConfig',
                'Required parameter "pubListConfig" was null or undefined when calling getCsl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/csl`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PubListConfigToJSON(requestParameters['pubListConfig']),
        };
    }

    /**
     */
    async getCslRaw(requestParameters: GetCslRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Csl>>> {
        const requestOptions = await this.getCslRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CslFromJSON));
    }

    /**
     */
    async getCsl(requestParameters: GetCslRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Csl>> {
        const response = await this.getCslRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSingleCsl without sending the request
     */
    async getSingleCslRequestOpts(requestParameters: GetSingleCslRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling getSingleCsl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/csl/{workId}`;
        urlPath = urlPath.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSingleCslRaw(requestParameters: GetSingleCslRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Csl>> {
        const requestOptions = await this.getSingleCslRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CslFromJSON(jsonValue));
    }

    /**
     */
    async getSingleCsl(requestParameters: GetSingleCslRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Csl> {
        const response = await this.getSingleCslRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
